import React, { useState, useEffect } from 'react'
import { useSummaryFormContext } from '../hook/summary-form'
import { Box, Paper, Text, Divider, SimpleGrid, Checkbox, Stack, Select, Loader } from '@mantine/core'
import { shipmentMethodType } from '../../../../../../helper/master-unit'
import { getAllCountryList } from '../../../../../../services/location'

const defaultTagList = [
  {
    value: '1',
    label: 'Wholesale',
    caption: 'Wholesale Product',
  },
  {
    value: '2',
    label: 'Retail',
    caption: 'Retail Product',
  },
  {
    value: '3',
    label: 'Hot Product',
    caption: 'Hot Product',
  },
  {
    value: '4',
    label: 'Local',
    caption: 'Local Product',
  },
  {
    value: '5',
    label: 'Imported Product',
    caption: 'Imported Product',
  },
  {
    value: '6',
    label: 'Fulfillment',
    caption: 'Fulfillment Product',
  },
  {
    value: '8',
    label: 'Virtual Product',
    caption: 'Virtual product will not calculate domestic shipping cost and logistic charge at checkout user',
  },
  {
    value: '9',
    label: 'COD',
    caption: 'COD Product',
  },
  {
    value: '10',
    label: 'Pre-order',
    caption: 'Pre-order Product',
  },
  {
    value: '11',
    label: 'Hot Product (Homepage)',
    caption: 'Hot Product for Homepage',
  },
]


const SummaryLabelProduct = () => {
  const form = useSummaryFormContext()

  const [loadingCountry, setLoadingCountry] = useState(true)
  const [countryList, setCountryList] = useState([])

  const handleGetListCountry = async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 300,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }

  useEffect(() => {
    handleGetListCountry()
  }, [])

  form.watch('tags', ({ value }) => {
    if (!value.includes('10')) {
      form.setValues((prev) => ({ ...prev, po_ship_from: null, po_shipment_method: null }))
    }
  })

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const mappingTagsLabel = (dataTags) => {

    const remapTagsLabels = dataTags.map((val, index) => {

      const showPOForm = () => {
        if (val.value === '10' && form.values.tags.includes('10')) {
          return (
            <Stack mt={10}>
              <Select
                size='xs'
                name='po-ship-from'
                label='Ship From'
                data={countryList}
                searchable
                clearable
                key={form.key('po_ship_from')}
                {...form.getInputProps('po_ship_from')}
                withAsterisk
                allowDeselect={false}
                nothingFoundMessage={!loadingCountry ? countryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
              />

              <Select
                size='xs'
                name='po-shipment-methods'
                label='Shipment Methods'
                data={shipmentMethodType}
                key={form.key('po_shipment_method')}
                {...form.getInputProps('po_shipment_method')}
                clearable
                withAsterisk
                allowDeselect={false}
              />
            </Stack>
          )
        }
      }

      return (
        <Paper key={index} p={'md'} withBorder shadow="xs" radius="md">
          <Checkbox
            label={<Text fz={13} fw={600} tt='capitalize'>{val.label}</Text>}
            description={<Box h={30}><Text fz={10.2} lineClamp={2} >{val.caption}</Text></Box>}
            value={val.value}
          />

          {showPOForm()}
        </Paper>
      )
    })

    return remapTagsLabels
  }

  return (
    <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
      <Text fw={500}>
        Product Label
      </Text>

      <Divider my={10} />
      <Checkbox.Group
        key={form.key('tags')}
        {...form.getInputProps('tags')}
      >
        <SimpleGrid cols={5} spacing={'lg'} verticalSpacing={'lg'} my={'lg'}>
          {mappingTagsLabel(defaultTagList)}
        </SimpleGrid>
      </Checkbox.Group>
    </Paper>
  )
}

export default SummaryLabelProduct